import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Icon from '../../components/Icon';
import { handleErr, paginationPageSize } from '../../utils/functions';
import { useUI } from '../../UIContext';
import { get } from '../../services/api';
import ListPage from '../../components/ListPage';

function Modules() {
    const amountByPage = paginationPageSize();
    const page = 1;

    const { setMessage, setLoading } = useUI();
    const [modules, setModules] = useState([]);
    const [modulesFiltered, setModulesFiltered] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize, setPageSize] = useState(amountByPage);
    const [pageTotal, setPageTotal] = useState(0);
    const navigate = useNavigate();

    function onClickUpdateModule(moduleId) {
        navigate(`/modules/update/${moduleId}`);
    }

    const tableCols = [
        {
            dataIndex: 'name',
            title: 'Módulo',
            render: (value, _) => (
                <span>{value}</span>
            )
        },
        {
            title: 'Ações',
            width: '120px',
            render: (_, row) => (
                <button onClick={() => onClickUpdateModule(row.id)} className='border-button edit-button glass-button-effect-15'>
                    <Icon iconClass='icon-pencil' size={16} />
                    Editar
                </button>
            )
        }
    ];

    useEffect(() => {
        async function getModules() {
            setLoading(true);

            await get('/module', true, setMessage,
                (response) => {
                    const modulesReturned = response.data;

                    setPageTotal(modulesReturned.length);
                    setModules(modulesReturned);
                },
                (err) => {
                    handleErr(setMessage, `Falha ao obter os módulos: ${err}`);
                },
                () => {
                    setLoading(false);
                }
            )
        }

        getModules();
    }, [setModules, setMessage, setLoading]);

    useEffect(() => {
        if (!modules || modules.length === 0) {
            setModulesFiltered([]);
            setPageTotal(0);
            return;
        }

        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + pageSize;

        const modulesFound = modules?.filter(module => 
            module.name?.toLowerCase().includes(searchTerm?.toLowerCase())
        );

        setPageTotal(modulesFound.length);
        setModulesFiltered(modulesFound.slice(startIndex, endIndex));

    }, [searchTerm, page, pageSize, modules]);

    return (
        <ListPage
            title='Gestão de Módulos'
            addButtonTitle='Novo módulo'
            onClickAddButton={() => navigate('/modules/create')}
            onChangeSearch={(e) => setSearchTerm(e.target.value)}
            tableCols={tableCols}
            dataFiltered={modulesFiltered}
            tablePageTotal={pageTotal}
            onChangeTablePage={() => { setPageSize(pageSize + amountByPage) }}
        />
    );
}

export default Modules;